import { round } from "./math";

const alphaFormatter = new Intl.NumberFormat("en-US", {
    useGrouping: false,
    minimumFractionDigits: 1,
    maximumFractionDigits: 2
});

const formatter = {
    percentage: (value: number, precision = 0) => `${round(value * 100, precision)}%`,
    unit: (value: number, densityScale: number): number => round(value / densityScale, 1),
    withUnit: (value: number, dimensionSuffix: string) => `${value}${dimensionSuffix}`,
    withTextUnit: (value: number, textDimensionSuffix: string) => `${value}${textDimensionSuffix}`,
    length: (value: number, densityScale: number, dimensionSuffix: string) =>
        formatter.withUnit(round(value / densityScale, 1), dimensionSuffix),
    textLength: (value: number, densityScale: number, textDimensionSuffix: string) =>
        formatter.withTextUnit(round(value / densityScale, 1), textDimensionSuffix),
    letterSpacing: (value: number, densityScale: number, textDimensionSuffix: string) =>
        formatter.withTextUnit(round(value / densityScale, 2), textDimensionSuffix),
    fontVariationAxis: (value: number) => String(round(value, 2)),
    alpha: (value: number) => alphaFormatter.format(value)
};

export default formatter;
